import invert from 'lodash/invert';

import { AssetTypeCode } from 'types/models/asset-type';
import { WeatherStationAssociatedSamplePoints } from 'types/models/samplePoint';
import { WeatherAssetType } from 'types/weather.enum';

export type HiddenKey = keyof WeatherStationAssociatedSamplePoints;

// Because of the limitation of lodash/invert, asset type code needs to be the value here. Otherwise, after inversion,
// the key (asset type code) will be a string.
const HIDDEN_KEY_TO_WEATHER_ASSET_TYPE: Record<HiddenKey, WeatherAssetType> = {
  'barometricPressure': AssetTypeCode.BAROMETRIC_PRESSURE,
  'battery': AssetTypeCode.WEATHER_STATION_BATTERY,
  'deltaT': AssetTypeCode.DELTA_T,
  'dewPoint': AssetTypeCode.DEW_POINT,
  'evapotranspiration': AssetTypeCode.EVAPOTRANSPIRATION,
  'humidity': AssetTypeCode.HUMIDITY,
  'rainfall': AssetTypeCode.RAIN_GAUGE,
  'soilMoisture': AssetTypeCode.SOIL,
  'soilTemperature': AssetTypeCode.SOIL_TEMPERATURE,
  'solarRadiation': AssetTypeCode.SOLAR_RADIATION,
  'temperature': AssetTypeCode.TEMPERATURE,
  'wind': AssetTypeCode.WIND
};

export const getAssetTypeId = (associatedHiddenKey: HiddenKey): WeatherAssetType => {
  return HIDDEN_KEY_TO_WEATHER_ASSET_TYPE[associatedHiddenKey];
};

export const getHiddenKey = (assetTypeId: AssetTypeCode): HiddenKey | undefined => {
  return invert(HIDDEN_KEY_TO_WEATHER_ASSET_TYPE)[assetTypeId] as HiddenKey | undefined;
};